import useCheckPC from "@repo/hooks/utils/useCheckPC";
import classNames from "classnames";
import React from "react";

import Icon from "@components/atoms/Icon";

import useLayout from "@hooks/reducerHooks/useLayout";

import { IconName } from "@const/enum";

const ABOVE_CHANNEL_TALK = "z-10000001";

const TOAST_COLOR = {
  error: "bg-toast-error",
  info: "bg-toast-info",
  success: "bg-toast-success",
  warning: "bg-toast-warning",
};

function Toast() {
  const { toast } = useLayout();

  const { isPC } = useCheckPC();

  return (
    <div
      className={classNames(
        "fixed inset-x-0 mx-auto my-0 flex items-center gap-2.5 rounded-md px-3 py-2",
        { "pc:w-[calc((100%_-_40px)*0.4*0.8)] pc:min-w-160 bottom-10": isPC },
        { "w-mobileFloatingBar bottom-5": !isPC },
        TOAST_COLOR[toast.type as keyof typeof TOAST_COLOR] || "",
        ABOVE_CHANNEL_TALK,
        !toast.isTransparent ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0",
        "transition-opacity duration-200 ease-[cubic-bezier(0.6,-0.2,0.4,1.2)]",
      )}
      id="toast"
    >
      {Boolean(toast.type) && (
        <Icon height="20px" name={IconName[`Toast_${toast.type}` as keyof typeof IconName]} width="20px" />
      )}
      <span>{toast.message || ""}</span>
    </div>
  );
}

export default Toast;
